import React from 'react';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { doctorImage, news } from '../mock';

const CareYouNeed = () => {
  return (
    <section id="news" className="py-16 lg:py-24 bg-white">
      <div className="max-w-[1240px] mx-auto px-6 grid lg:grid-cols-[1fr_1fr] gap-14 items-start">
        {/* Left */}
        <div className="relative">
          <div className="max-w-md">
            <h2 className="text-[40px] lg:text-[54px] leading-[0.98] font-bold tracking-tight text-neutral-900">
              The care you need <br />
              from <span className="font-serif-italic font-normal">therapists you trust</span>
            </h2>
            <Link to="/team" className="mt-8 inline-flex items-center gap-2 bg-[#CA0028] hover:bg-[#A80021] text-white text-[14px] font-medium pl-6 pr-2 py-2 rounded-full transition-colors">
              Meet Our Team
              <span className="w-8 h-8 grid place-items-center rounded-full bg-white/15">
                <ArrowRight size={14} />
              </span>
            </Link>
            <div className="mt-4 text-[14px] text-neutral-600">
              or,{' '}
              <a href="tel:+15192522752" className="inline-flex items-center gap-1 text-neutral-900 font-medium hover:text-[#CA0028] transition-colors">
                Call +1-519-252-2752
                <ArrowRight size={12} />
              </a>
            </div>
          </div>
          <div className="mt-10 rounded-[24px] overflow-hidden aspect-[4/5] max-w-sm">
            <img src={doctorImage} alt="Trusted physiotherapist" className="w-full h-full object-cover" loading="lazy" />
          </div>
        </div>

        {/* Right - News */}
        <div className="lg:pt-4">
          <h4 className="text-[15px] font-semibold text-neutral-900">News &amp; Press</h4>
          <div className="mt-4">
            {news.map((n) => (
              <Link
                key={n.id}
                to={`/news/${n.slug}`}
                className="group flex items-start justify-between gap-6 border-t border-neutral-200 py-6 hover:bg-neutral-50 -mx-3 px-3 rounded-lg transition-colors"
              >
                <div>
                  <div className="flex items-center gap-3 text-[12px] text-neutral-500">
                    <span className="font-medium text-neutral-700">{n.tag}</span>
                    <span className="w-1 h-1 rounded-full bg-neutral-300" />
                    <span>{n.date}</span>
                  </div>
                  <p className="mt-2 text-[16px] font-medium text-neutral-900 leading-snug group-hover:text-[#CA0028] transition-colors">
                    {n.title}
                  </p>
                </div>
                <ArrowUpRight size={18} className="mt-1 shrink-0 text-neutral-400 group-hover:text-neutral-900 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
              </Link>
            ))}
            <div className="border-t border-neutral-200" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default CareYouNeed;
